/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const apiGetUsers = async (params = {}) => {
  return Request.call({
    url: `/micro/users`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetUser = async (id) => {
  return Request.call({
    url: `/micro/users/${id}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateNewUser = async (data) => {
  return Request.call({
    url: `/micro/users`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiEditUser = async (id, data) => {
  return Request.call({
    url: `/micro/users/${id}`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiDeleteUser = async (id) => {
  return Request.call({
    url: `/micro/users/${id}`,
    method: 'DELETE',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};